/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { NotificationProvider } from "../../../contexts/notification-context";
import { useFileManagement } from "../../../services/file-management";
import { Header } from "../../common/header";
import { Footer } from "../main-page/footer";
import { InviteButton } from "../../common/invite-button";
import { getIndustryRoles } from "../../../services/generalInfo";
import { TGenericGUIDName } from "../../../lib/types/general";
import { useRouteNavigation } from "../../../lib/common/routes";
import { TApiLab } from "../../../lib/types/labs";
import { useLabs } from "../../../services/laboratories";
import { DentalLabSearchFilterPanel, TLabsFilterSettings } from "../../common/dental-lab-search-filter-panel";
import { getRegions } from "../../../services/regions";
import { getCacheKillQueryString } from "../../../lib/common/api";
import { ASSETS_ROUTES, DEVICES_SIZES_IN_PX, LAB_SEARCH_PAGINATION_SIZE } from "../../../lib/common/constants";
import { Pagination } from "../../common/pagination";
import { Spinner } from "../../common/spinner";
import { BackButton } from "../../common/backbutton";
import { phoneFormatHandler } from "../../../lib/common/validation";
import { evaluators, useWindowSizeMatch } from "../../../lib/window-size-matcher";
import { useMapLabLogic } from "../../common/map/map";
import { TEmployeeRole } from "../../../lib/types/employee_roles";

type TDentalLabInfoProps = {
    userInfo: TApiLab;
    industryRoles: TEmployeeRole[];
    regions: TGenericGUIDName[];
    clickHandler: (lab: TApiLab, e: React.MouseEvent) => void;
    mapView: boolean;
};
export const DentalLabInfo = (props: TDentalLabInfoProps) => {
    const { userInfo, industryRoles, regions, clickHandler, mapView } = props;
    const { getImagePath } = useFileManagement();
    const { navigateRouteClickHandler } = useRouteNavigation();

    const [imgLogo, setImgLogo] = useState<string | null>(null);
    useEffect(() => {
        setImgLogo(
            userInfo.images?.logo
                ? getImagePath(userInfo.images.logo, "fixed", userInfo.guid) + "?" + getCacheKillQueryString()
                : ASSETS_ROUTES.IMGS.labAvatarUrl,
        );
    }, []);
    //const imgBackground = userInfo.images?.background && getImagePath(userInfo.images?.background, userInfo.id);
    const openPositions = userInfo.other?.positions?.map((posId) => industryRoles.find((rol) => rol.id === posId.id)?.name);
    const currRegion = userInfo.other.desiredRegion
        ? regions
              .filter((region) => userInfo.other.desiredRegion.includes(region.guid))
              .map((region) => region.name)
              .join(", ")
        : "";
    const handleSeeProfileClick = (userInfo: TApiLab, e: React.MouseEvent) => {
        e.stopPropagation();
        navigateRouteClickHandler("dentalLabInfo", e, userInfo.id.toString(), true);
    };
    const OpenPositionListExpandable = () => {
        const [expanded, setExpanded] = useState<boolean>(false);
        const posAmount = openPositions.length;
        const posCollapsedLength = 4;
        const posRemaining = posAmount - posCollapsedLength;

        const resumedPossitions = openPositions.slice(0, 4);

        return (
            <div>
                {expanded && (
                    <>
                        {openPositions.map((pos, index) => (
                            <span key={`open_position_badge_${pos}_${index}`} className="badge bg-white border border-2 border-info text-dark w-auto m-1 px-2">
                                {pos}
                            </span>
                        ))}
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                setExpanded(false);
                            }}
                            className="btn btn-link text-info showLessBtn p-0"
                        >
                            show less
                        </button>
                    </>
                )}
                {!expanded && (
                    <>
                        {resumedPossitions.map((p, index) => (
                            <span key={`search_card_position_badge_${p}_${index}`} className="badge bg-white border border-2 border-info text-dark w-auto px-2">
                                {p}
                            </span>
                        ))}
                        {posRemaining > 0 && (
                            <button
                                className="btn btn-link text-info showLessBtn p-0"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setExpanded(true);
                                }}
                            >
                                ... and {posRemaining} more
                            </button>
                        )}
                    </>
                )}
            </div>
        );
    };
    const title = `${userInfo.name} wants to connect with you.`;
    const showInviteButton = !userInfo.inmycontactlist && !userInfo.invitationsenttome && userInfo.invitationsentstate !== "accepted";
    const hasPendingInvitation = !userInfo.inmycontactlist && userInfo.invitationsenttome;

    return (
        <div className={`search-card p-3 card card-maps position-relative ${mapView ? "w-100 flex-fill" : ""}`}>
            <div className="position-absolute top-0 end-0 me-2">
                <span className="badge rounded-pill search-card__type-badge">{userInfo.business_type_name}</span>
            </div>
            <div
                className="card-body border-0 rounded-3 p-1 p-md-2"
                onClick={(e) => {
                    e.stopPropagation();
                    clickHandler(userInfo, e);
                }}
                role="button"
            >
                <div className="row align-items-start text-center text-md-start mx-0 mt-2">
                    <div className="col-3 col-md-3 px-0 pe-2 text-center">
                        {!!imgLogo && (
                            <div className="position-relative d-inline-block">
                                <img
                                    className="card-img-top rounded-circle shadow card-tech-top__logo card-tech-top__lab_logo border border-1 "
                                    src={imgLogo}
                                    alt="Lab Logo"
                                />
                                {userInfo.inmycontactlist && (
                                    <div className="contact-lab bg-info text-white" data-tooltip="In Contact">
                                        <i className="fa-solid fa-user-check fa-xs"></i>
                                    </div>
                                )}
                                {!userInfo.inmycontactlist && (
                                    <div>
                                        {!userInfo.invitationsenttome && userInfo.invitationsentstate === "unread" && (
                                            <div className="no-contact-lab bg-white" data-tooltip="Invitation sent. Awaiting their reply.">
                                                <i className="fa-solid fa-user-clock fa-xs"></i>
                                            </div>
                                        )}
                                        {userInfo.invitationsenttome && (
                                            <div className="invitation-requested-lab bg-warning" data-tooltip={title}>
                                                <i className="fa-solid fa-envelope fa-xs"></i>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="col-9 col-md-9 px-0">
                        <div className="row g-0 align-items-start">
                            <div className="col-12 pe-4 pe-md-5">
                                <h6 className="fw-bold lh-sm mb-1 employer-name text-start ">{userInfo.name}</h6>
                            </div>
                        </div>
                        {!!currRegion && (
                            <div className="row gx-2 mb-1 helper-text mx-0">
                                <div className="col-auto px-0 text-info">
                                    <i className="fa-solid fa-earth-americas"></i>
                                </div>
                                <div className="col pe-1 text-start">
                                    <small className="d-block text-truncate">{currRegion}</small>
                                </div>
                            </div>
                        )}
                        {!!userInfo.other.address?.city && !!userInfo.other.address.state && (
                            <div className="row gx-2 mb-1 helper-text mx-0">
                                <div className="col-auto px-0 text-info">
                                    <i className="fa-solid fa-location-dot"></i>
                                </div>
                                <div className="col pe-1 text-start">
                                    <small className="d-block">
                                        {userInfo.other.address?.street}
                                        {userInfo.other.address?.street_number ? `, ${userInfo.other.address.street_number}` : ""}{" "}
                                        {userInfo.other.address?.city}, {userInfo.other.address?.state}{" "}
                                    </small>
                                </div>
                            </div>
                        )}
                        {!!userInfo.other.phone && (
                            <div className="row gx-2 mb-1 helper-text mx-0">
                                <div className="col-auto px-0 text-info">
                                    <i className="fa-solid fa-phone"></i>
                                </div>
                                <div className="col pe-1 text-start">
                                    <small className="d-block">{phoneFormatHandler(userInfo.other.phone)}</small>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="row px-1 px-md-2 pt-3 pb-2 mt-2 mx-0 text-start border-top border-light-subtle">
                    {openPositions && openPositions.length > 0 && (
                        <>
                            <p className="fw-semibold text-uppercase text-muted mb-1 helper-text">Available Position(s)</p>
                            <OpenPositionListExpandable />
                        </>
                    )}
                </div>
            </div>
            <div className="card-footer border-0 bg-white pt-1 px-0 pb-0 mt-auto">
                <div className={`${mapView ? "row g-3 mx-0" : ""}`}>
                    {showInviteButton && (
                        <div className={mapView ? "col-9" : "col-12"}>
                            <InviteButton userToInviteId={userInfo.id} userToInviteInvitationState={userInfo.invitationsentstate} userType="lab" />
                        </div>
                    )}
                    {hasPendingInvitation && (
                        <div className="col-12">
                            <button className="btn btn-warning w-100 fw-bold" onClick={(e) => handleSeeProfileClick(userInfo, e)}>
                                <small>REVIEW INVITATION</small>
                            </button>
                        </div>
                    )}
                    {mapView && !hasPendingInvitation && (
                        <div className={showInviteButton ? "col-3" : "col-12"}>
                            <button
                                className={`btn btn-outline-info w-100`}
                                onClick={(e) => {
                                    handleSeeProfileClick(userInfo, e);
                                }}
                                aria-label="View profile"
                                title="View profile"
                            >
                                <i className="fa-solid fa-user"></i>
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export const DentalLabSearch = () => {
    const { getLabsSearch, state } = useLabs();
    const [labs, setLabs] = useState<TApiLab[]>([]);
    const [industryRoles, setIndustryRoles] = useState<TEmployeeRole[]>([]);
    const [regions, setRegions] = useState<TGenericGUIDName[]>([]);
    const [totalCount, setTotalCount] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [mapView, setMapView] = useState(true);

    const refFilter = useRef<HTMLDivElement>(null);
    const viewMapAnchorRef = useRef<HTMLDivElement>(null);
    const mapCardsRef = useRef<HTMLDivElement>(null);
    const searchMapRef = useRef<HTMLDivElement>(null);

    const regionFilters = useRef<string[]>();
    const industryRolesFilters = useRef<number[]>();
    const businessTypesFilter = useRef<number[]>();
    const nameFilter = useRef<string[]>();

    const { centerLabOnMap, selectedLab, enableMap } = useMapLabLogic(searchMapRef);
    const { navigateRouteClickHandler } = useRouteNavigation();

    const { conditionFulfilled: isSmallDevice } = useWindowSizeMatch({
        condition: evaluators.lessThan(DEVICES_SIZES_IN_PX.medium),
    });

    useEffect(() => {
        Promise.all([getRegions(), getIndustryRoles()]).then(([regions, roles]) => {
            setIndustryRoles(roles);
            setRegions(regions);
        });
    }, []);

    const refreshList = async (offset: number) => {
        const labsResult = await getLabsSearch(
            {
                filterPositions: industryRolesFilters.current,
                filterRegions: regionFilters.current,
                filterName: nameFilter.current,
                businessTypesIds: businessTypesFilter.current,
            },
            offset,
        );
        if (mapView) {
            enableMap(labsResult.labs);
        }

        setLabs(labsResult.labs);
        setTotalCount(labsResult.totalCount);
        setPageNumber(offset + 1);
    };

    const resetCallback = () => {
        regionFilters.current = undefined;
        industryRolesFilters.current = undefined;
        nameFilter.current = undefined;
        businessTypesFilter.current = undefined;
        refreshList(0);
    };

    const filterCallback = async (filterSettings: TLabsFilterSettings, offset = 0) => {
        regionFilters.current = filterSettings.regions ? filterSettings.regions.map((o) => o.data.id) : [];
        industryRolesFilters.current = filterSettings.industryRoles ? filterSettings.industryRoles.map((o) => Number(o.data.id)) : [];
        nameFilter.current = filterSettings.names ? filterSettings.names.map((o) => o.data.name) : [];
        businessTypesFilter.current = filterSettings.businessTypes ? filterSettings.businessTypes.map((o) => Number(o.data.id)) : [];
        await refreshList(offset);
    };

    const viewMapHandler = () => {
        viewMapAnchorRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
        setMapView((prev) => {
            if (!prev) {
                enableMap(labs, searchMapRef);
            }
            return !prev;
        });
    };

    const notificationRef = useRef<any>();

    const handleLabClick = (lab: TApiLab, e: React.MouseEvent) => {
        if (notificationRef.current) {
            notificationRef.current.classList.add("card-notification-show");
        }

        if (mapView) {
            centerLabOnMap(lab);
        } else {
            navigateRouteClickHandler("dentalLabInfo", e, lab.id.toString(), true);
        }
    };
    return (
        <>
            <NotificationProvider>
                <Header title="" />
                <div className="container-fluid">
                    <div className="container">
                        <div className="row align-items-center gx-2 py-3 mx-lg-5">
                            <div className="col-auto">
                                <BackButton />
                            </div>
                            <div className="col text-center">
                                <h2>Dental Employers List</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid" ref={refFilter}>
                    <div ref={viewMapAnchorRef}></div>
                    <div className="row justify-content-center mx-auto mx-lg-5">
                        <div className="col-12 col-lg-3 mb-3 mb-lg-4">
                            <button className="btn btn-primary shadow border-2 fw-bold py-2 px-4 w-100 mt-2" onClick={viewMapHandler}>
                                <i className={`fa-solid fa-xs me-2 ${mapView ? "fa-list-ul" : "fa-map-location-dot"}`} />

                                {mapView ? "View List" : "View Map"}
                            </button>
                        </div>
                        <div className="col-12">
                            <DentalLabSearchFilterPanel
                                searchJustFromContactList={false}
                                filterCallback={(settings) => filterCallback(settings)}
                                resetCallback={resetCallback}
                            />
                        </div>
                    </div>
                </div>

                {!mapView && (
                    <div className="container-fluid">
                        {state === "working" && (
                            <div className="text-center">
                                <Spinner spinnerColor="text-primary fa-xl" />
                            </div>
                        )}
                        {state === "idle" && (
                            <div className="container">
                                {labs.length > 0 ? (
                                    <div className="row p-4 justify-content-center gap-4">
                                        {labs.map((userInfo) => (
                                            <DentalLabInfo
                                                key={userInfo.id}
                                                industryRoles={industryRoles}
                                                regions={regions}
                                                userInfo={userInfo}
                                                mapView={false}
                                                clickHandler={(userInfo, e) => {
                                                    handleLabClick(userInfo, e);
                                                }}
                                            />
                                        ))}
                                        {totalCount > LAB_SEARCH_PAGINATION_SIZE && (
                                            <div className="col-12 mt-3">
                                                <Pagination
                                                    currentPage={pageNumber}
                                                    totalCount={totalCount}
                                                    itemsPerPage={LAB_SEARCH_PAGINATION_SIZE}
                                                    refObject={refFilter}
                                                    onPageChange={(offset) => {
                                                        refreshList(offset);
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <p className="text-center text-primary mt-3">No matching dental employers found.</p>
                                )}
                            </div>
                        )}
                    </div>
                )}

                {mapView && (
                    <div className="container-fluid">
                        <div className="container">
                            <div className="row justify-content-center">
                                {/* Map */}
                                <div className="col-12 col-lg-5 rounded map-container map-container__searchLabs" ref={searchMapRef}></div>
                                {/* Lab List */}
                                <div className="col-12 col-lg-6 pb-lg-0 " ref={mapCardsRef}>
                                    {labs.length > 0 ? (
                                        <div className="row row-gap-4 col-gap-1 lablist-map__scroll lablist-map__scroll__searchLabs">
                                            {/*Mobile version card wont show unless marker was clicked*/}
                                            {selectedLab && isSmallDevice.fulfilled && (
                                                <DentalLabInfo
                                                    key={`search_card_map_view_mobile_lab_${selectedLab.id}`}
                                                    industryRoles={industryRoles}
                                                    userInfo={selectedLab}
                                                    clickHandler={(lab, e) => {
                                                        handleLabClick(lab, e);
                                                    }}
                                                    regions={regions}
                                                    mapView={true}
                                                />
                                            )}
                                            {/*Desktop version */}
                                            {!isSmallDevice.fulfilled &&
                                                labs.map((lab) => (
                                                    <div
                                                        key={`search_card_map_column_${lab.id}`}
                                                        className={`scrollToLab-${lab.id} col-12 col-xl-6 d-flex text-center`}
                                                    >
                                                        <DentalLabInfo
                                                            industryRoles={industryRoles}
                                                            userInfo={lab}
                                                            clickHandler={(lab, e) => {
                                                                handleLabClick(lab, e);
                                                            }}
                                                            regions={regions}
                                                            mapView={true}
                                                        />
                                                    </div>
                                                ))}
                                            {isSmallDevice.fulfilled && (
                                                <div className="card map-pagination-card border-0 mb-4">
                                                    <p className="pt-lg-3 text-wrap fw-bold text-center">{labs.length} employers found within map area</p>
                                                    <small className="px-3 text-center text-wrap">
                                                        Looking for more employers? Use the filters to refine your search and click the pagination buttons below
                                                        to navigate through additional listings!
                                                    </small>
                                                </div>
                                            )}
                                            {totalCount > LAB_SEARCH_PAGINATION_SIZE && (
                                                <div className="col-11 mt-2">
                                                    <Pagination
                                                        currentPage={pageNumber}
                                                        totalCount={totalCount}
                                                        itemsPerPage={LAB_SEARCH_PAGINATION_SIZE}
                                                        refObject={refFilter}
                                                        onPageChange={(offset) => {
                                                            refreshList(offset);
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <p className="text-center text-primary mt-3">No matching dental employers found.</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer />
            </NotificationProvider>
        </>
    );
};
